import './assets/scss/Theme.scss';

import Routes from './routes/Routes';
import i18n from "./i18n";
import { Providers } from "_components/Providers";
import { AuthService } from "_services/auth.service";
import { LoggedAsTopBard } from "_components/LoggedAsTopBard";
import { Route, useGo } from "_utils/url";
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { enableDirectAccess } from "@legendapp/state/config/enable$GetSet"
import { enable_PeekAssign } from "@legendapp/state/config/enable_PeekAssign"

enableDirectAccess();
enable_PeekAssign();

const App = () => {
    i18n.changeLanguage('ptbr');
    AuthService.loadTokens();

    return (
        <BrowserRouter>
            <Providers>
                <LoggedAsTopBard />
                <Routes />
            </Providers>
        </BrowserRouter>
    );
};

export default App;
